import { isValidElement, PropsWithChildren } from 'react';
import { slugify } from '@bridebook/toolbox/src';

const CategorySection = ({ children }: PropsWithChildren) => (
  <div data-name="category-section">
    {Array.isArray(children)
      ? children.map((item) =>
          item ? (
            <div
              className="bg-white"
              key={`search-supplier-categories-category-section-item-${
                isValidElement(item) ? slugify(item.key) : ''
              }`}>
              {item}
            </div>
          ) : null,
        )
      : children}
  </div>
);

export default CategorySection;
